import React from "react";
import styled from "styled-components/native";
import { CheckBox } from "@components/atoms";
import { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { DefaultThemeValueType } from "../../../../styled";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { Image as ExpoImage } from "expo-image";
import { getImageSource, ImageSizePreset } from "@utils/image/imageOptimizer";

type ShareImageCardTypes = {
  imageChecked?: boolean | undefined;
  onPress?: () => void;
  imgURL?: string;
  onError?: () => void;
  genericIcon?: string;
  customIcon?: React.ReactNode;
  iconColor?: boolean;
};

const ShareImageCard = ({
  imageChecked,
  onPress,
  imgURL,
  onError,
  genericIcon,
  customIcon,
  iconColor,
}: ShareImageCardTypes) => {
  const theme = useTheme();
  const { disableImageZoom } = useUserInfo();
  const hasIcon = !!customIcon || !!genericIcon;
  return (
    <ImageContainer>
      <ImageResourceContainer genericIcon={hasIcon}>
        {imgURL ? (
          <ExpoImage
            style={{
              width: 140,
              height: 140,
              borderRadius: 8,
              backgroundColor: theme["core-01"],
            }}
            source={{
              uri: getImageSource(imgURL, ImageSizePreset.SHARE_IMAGE).uri,
            }}
            onError={onError}
            contentFit={disableImageZoom() ? "contain" : "cover"}
          />
        ) : customIcon ? (
          customIcon
        ) : (
          <VDBIcon
            name={genericIcon}
            size={50}
            color={theme["core-06"]}
            variant={IconsVariant.VDBCustom}
          />
        )}
      </ImageResourceContainer>
      <CheckboxContainer theme={theme} imageChecked={imageChecked}>
        <CheckBoxOverlay>
          <CheckBox
            fillColor={theme["knob-bor"]}
            checkBoxSize={20}
            isChecked={imageChecked}
            onPress={onPress}
            iconColor={iconColor}
          />
        </CheckBoxOverlay>
      </CheckboxContainer>
    </ImageContainer>
  );
};

const ImageContainer = styled.View`
  width: 142px;
  height: 142px;
  border-radius: 8px;
  border-color: ${({ theme }) => theme["core-03"]};
  border-width: 1px;
`;

const ImageResourceContainer = styled.View<{
  genericIcon?: boolean;
}>`
  width: 100%;
  position: absolute;
  border-radius: 8px;
  top: ${({ genericIcon }) => (genericIcon ? 40 : 0)};
  left: ${({ genericIcon }) => (genericIcon ? 40 : 0)};
`;

const CheckBoxOverlay = styled.View<any>`
  background-color: ${({ theme }) => theme["core-01"]};
  width: 20px;
  height: 20px;
  right: 1px;
  border-radius: 8px;
`;

const CheckboxContainer = styled.View<{
  theme?: DefaultThemeValueType;
  imageChecked?: boolean;
}>`
  height: 32px;
  width: 32px;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 16px;
  background-color: ${({ theme, imageChecked }) =>
    theme[imageChecked ? "over-02" : "over-03"]};
  position: "absolute";
  top: 0px;
  left: 0px;
  align-items: center;
  justify-content: center;
`;

export default ShareImageCard;
